(() => {
  const STYLE_ID = 'RosemaryPrimarySearchStyles';
  const MOBILE_BREAKPOINT = window.matchMedia('(max-width: 989px)');
  let requestController = null;
  let searchTimer = 0;

  const escapeHtml = (value) => String(value || '').replace(/[&<>"']/g, (character) => ({
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#039;'
  })[character]);

  const getCopy = () => {
    const isArabic = document.documentElement.lang.toLowerCase().startsWith('ar');
    return isArabic
      ? {
          loading: 'جاري البحث...',
          empty: 'لا توجد منتجات مطابقة.',
          error: 'تعذر البحث الآن. حاولي مرة أخرى.',
          all: 'عرض كل نتائج البحث',
          label: 'بحث'
        }
      : {
          loading: 'Searching...',
          empty: 'No matching products found.',
          error: 'Search is unavailable right now. Please try again.',
          all: 'View all search results',
          label: 'Search'
        };
  };

  const addStyles = () => {
    if (document.getElementById(STYLE_ID)) return;
    const style = document.createElement('style');
    style.id = STYLE_ID;
    style.textContent = `
      .rh-header-search {
        position: relative;
        display: grid;
        isolation: isolate;
      }

      .rh-header-search input[type="search"] {
        padding-inline-end: 68px !important;
      }

      .rh-primary-search__submit {
        position: absolute !important;
        inset-block-start: 50%;
        inset-inline-end: 8px;
        z-index: 2;
        display: inline-grid !important;
        width: 46px !important;
        min-width: 46px !important;
        height: 46px !important;
        min-height: 46px !important;
        place-items: center;
        padding: 0 !important;
        border: 0 !important;
        border-radius: 50% !important;
        background: transparent !important;
        color: #000 !important;
        box-shadow: none !important;
        transform: translateY(-50%) !important;
      }

      .rh-primary-search__submit:hover,
      .rh-primary-search__submit:focus-visible {
        background: rgb(0 0 0 / .06) !important;
      }

      .rh-primary-search__submit svg {
        width: 22px;
        height: 22px;
        fill: none;
        stroke: currentColor;
        stroke-width: 1.8;
        stroke-linecap: round;
        stroke-linejoin: round;
      }

      .rh-primary-search__results {
        position: absolute;
        inset-block-start: calc(100% + 8px);
        inset-inline: 0;
        z-index: 150;
        max-height: min(520px, 70vh);
        overflow: auto;
        padding: 10px;
        border: 1px solid #e5e5e5;
        border-radius: 8px;
        background: #fff;
        color: #000;
        box-shadow: 0 18px 48px rgb(0 0 0 / .14);
      }

      .rh-primary-search__results[hidden] {
        display: none !important;
      }

      .rh-primary-search__status {
        margin: 0;
        padding: 18px 14px;
        color: #666;
        font-size: 13px;
        text-align: center;
      }

      .rh-primary-search__grid {
        display: grid;
        grid-template-columns: repeat(2, minmax(0, 1fr));
        gap: 8px;
      }

      .rh-primary-search__result {
        display: grid;
        grid-template-columns: 58px minmax(0, 1fr);
        align-items: center;
        gap: 10px;
        min-width: 0;
        padding: 7px;
        border: 1px solid transparent;
        border-radius: 7px;
        color: #000 !important;
        text-decoration: none;
      }

      .rh-primary-search__result:hover,
      .rh-primary-search__result:focus-visible {
        border-color: #e5e5e5;
        background: #f7f7f7;
        opacity: 1 !important;
      }

      .rh-primary-search__result img,
      .rh-primary-search__placeholder {
        display: grid;
        width: 58px;
        height: 58px;
        place-items: center;
        border-radius: 5px;
        background: #f5f5f5;
        object-fit: contain;
      }

      .rh-primary-search__text {
        display: grid;
        min-width: 0;
        gap: 3px;
      }

      .rh-primary-search__title {
        display: -webkit-box;
        min-width: 0;
        overflow: hidden;
        color: #000;
        font-size: 13px;
        font-weight: 700;
        line-height: 1.55;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
      }

      .rh-primary-search__price {
        color: #666;
        font-size: 12px;
        font-weight: 700;
      }

      .rh-primary-search__all {
        display: flex;
        min-height: 42px;
        align-items: center;
        justify-content: center;
        margin-block-start: 10px;
        border-block-start: 1px solid #ededed;
        color: #000 !important;
        font-size: 13px;
        font-weight: 800;
        text-decoration: none;
      }

      .rh-search__results .rh-primary-search__grid {
        grid-template-columns: repeat(4, minmax(0, 1fr));
      }

      .rh-search__results .rh-primary-search__result {
        grid-template-columns: 72px minmax(0, 1fr);
      }

      .rh-search__results .rh-primary-search__result img,
      .rh-search__results .rh-primary-search__placeholder {
        width: 72px;
        height: 72px;
      }

      .rh-primary-search-mobile {
        display: none !important;
      }

      @media (max-width: 1180px) and (min-width: 990px) {
        .rh-primary-search__grid,
        .rh-search__results .rh-primary-search__grid {
          grid-template-columns: 1fr;
        }
      }

      @media (max-width: 989px) {
        .rh-primary-search-mobile {
          display: inline-grid !important;
        }

        .rh-search__results .rh-primary-search__grid {
          grid-template-columns: repeat(2, minmax(0, 1fr));
        }

        .rh-search__results .rh-primary-search__result {
          grid-template-columns: 52px minmax(0, 1fr);
        }

        .rh-search__results .rh-primary-search__result img,
        .rh-search__results .rh-primary-search__placeholder {
          width: 52px;
          height: 52px;
        }
      }
    `;
    document.head.appendChild(style);
  };

  const ensureHiddenInput = (form, name, value) => {
    let input = form.querySelector(`input[name="${name}"]`);
    if (!input) {
      input = document.createElement('input');
      input.type = 'hidden';
      input.name = name;
      form.appendChild(input);
    }
    input.value = value;
  };

  const normalSearchUrl = (form, query) => {
    const url = new URL(form.action, window.location.origin);
    url.searchParams.set('q', query);
    url.searchParams.set('type', 'product');
    url.searchParams.set('options[prefix]', 'last');
    return url;
  };

  const dataSearchUrl = (form, query) => {
    const url = normalSearchUrl(form, query);
    url.searchParams.set('options[unavailable_products]', 'hide');
    url.searchParams.set('view', 'rosemary-primary');

    const currentUrl = new URL(window.location.href);
    ['preview_theme_id', '_fd', 'pb'].forEach((key) => {
      if (currentUrl.searchParams.has(key)) {
        url.searchParams.set(key, currentUrl.searchParams.get(key));
      }
    });

    return url;
  };

  const closeResults = (input, results) => {
    if (!results) return;
    results.hidden = true;
    results.replaceChildren();
    results.classList.remove('is-loading', 'has-results');
    input?.setAttribute('aria-expanded', 'false');
  };

  const renderResults = ({ form, input, results, products, query, message = '' }) => {
    const copy = getCopy();
    if (!results || !input) return;

    if (message) {
      results.innerHTML = `<p class="rh-primary-search__status">${escapeHtml(message)}</p>`;
    } else if (!products.length) {
      results.innerHTML = `<p class="rh-primary-search__status">${escapeHtml(copy.empty)}</p>`;
    } else {
      results.innerHTML = `
        <div class="rh-primary-search__grid">
          ${products.slice(0, 6).map((product) => `
            <a class="rh-primary-search__result" href="${escapeHtml(product.url)}">
              ${product.image
                ? `<img src="${escapeHtml(product.image)}" alt="${escapeHtml(product.title)}" loading="lazy">`
                : '<span class="rh-primary-search__placeholder" aria-hidden="true"></span>'}
              <span class="rh-primary-search__text">
                <span class="rh-primary-search__title">${escapeHtml(product.title)}</span>
                ${product.price ? `<span class="rh-primary-search__price">${escapeHtml(product.price)}</span>` : ''}
              </span>
            </a>
          `).join('')}
        </div>
        <a class="rh-primary-search__all" href="${escapeHtml(normalSearchUrl(form, query).toString())}">${escapeHtml(copy.all)}</a>
      `;
    }

    results.hidden = false;
    results.classList.remove('is-loading');
    results.classList.add('has-results');
    input.setAttribute('aria-expanded', 'true');
  };

  const searchProducts = ({ form, input, results, query }) => {
    const copy = getCopy();
    window.clearTimeout(searchTimer);
    requestController?.abort();

    if (query.length < 2) {
      closeResults(input, results);
      return;
    }

    results.hidden = false;
    results.classList.remove('has-results');
    results.classList.add('is-loading');
    results.innerHTML = `<p class="rh-primary-search__status">${escapeHtml(copy.loading)}</p>`;
    input.setAttribute('aria-expanded', 'true');

    searchTimer = window.setTimeout(async () => {
      try {
        requestController = new AbortController();
        const response = await fetch(dataSearchUrl(form, query), {
          headers: { Accept: 'text/html' },
          signal: requestController.signal,
          cache: 'no-store'
        });
        if (!response.ok) throw new Error('Primary search failed');

        const html = await response.text();
        const documentFragment = new DOMParser().parseFromString(html, 'text/html');
        const dataNode = documentFragment.querySelector('[data-rosemary-primary-search-data]');
        if (!dataNode) throw new Error('Search data template was not rendered');

        const payload = JSON.parse(dataNode.textContent || '{}');
        const products = Array.isArray(payload.products) ? payload.products : [];
        renderResults({ form, input, results, products, query });
      } catch (error) {
        if (error.name === 'AbortError') return;
        renderResults({ form, input, results, products: [], query, message: copy.error });
      }
    }, 200);
  };

  const bindSearch = ({ form, input, results, closeOnOutside = false }) => {
    if (!form || !input || !results || input.dataset.regularSearchReady === 'true') return;

    input.dataset.regularSearchReady = 'true';
    input.removeAttribute('data-search-open');
    input.removeAttribute('data-predictive-input');
    input.setAttribute('enterkeyhint', 'search');
    input.setAttribute('aria-autocomplete', 'list');
    input.setAttribute('aria-expanded', 'false');

    ensureHiddenInput(form, 'type', 'product');
    ensureHiddenInput(form, 'options[prefix]', 'last');

    input.addEventListener('input', () => {
      searchProducts({ form, input, results, query: input.value.trim() });
    });

    input.addEventListener('focus', () => {
      const query = input.value.trim();
      if (query.length >= 2) searchProducts({ form, input, results, query });
    });

    input.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') {
        closeResults(input, results);
        input.blur();
      }
    });

    form.addEventListener('submit', (event) => {
      if (input.value.trim()) return;
      event.preventDefault();
      input.focus();
    });

    if (closeOnOutside) {
      document.addEventListener('click', (event) => {
        if (!form.contains(event.target)) closeResults(input, results);
      });
    }
  };

  const enhanceDesktopSearch = () => {
    const form = document.querySelector('.rh-header-search');
    if (!form) return;
    const input = form.querySelector('input[type="search"][name="q"]');
    if (!input) return;

    const currentQuery = new URL(window.location.href).searchParams.get('q');
    if (currentQuery && !input.value) input.value = currentQuery;

    let submit = form.querySelector('.rh-primary-search__submit');
    if (!submit) {
      submit = document.createElement('button');
      submit.type = 'submit';
      submit.className = 'rh-primary-search__submit';
      submit.setAttribute('aria-label', getCopy().label);
      submit.innerHTML = '<svg viewBox="0 0 24 24" aria-hidden="true"><circle cx="11" cy="11" r="7"></circle><path d="m16.5 16.5 4 4"></path></svg>';
      form.appendChild(submit);
    }

    let results = form.querySelector('[data-primary-search-results]');
    if (!results) {
      results = document.createElement('div');
      results.id = 'RosemaryHeaderSearchResults';
      results.className = 'rh-primary-search__results';
      results.setAttribute('data-primary-search-results', '');
      results.setAttribute('role', 'listbox');
      results.setAttribute('aria-live', 'polite');
      results.hidden = true;
      form.appendChild(results);
    }

    input.setAttribute('aria-controls', results.id);
    bindSearch({ form, input, results, closeOnOutside: true });
  };

  const enhanceOverlaySearch = () => {
    const overlay = document.querySelector('[data-search-overlay]');
    const form = overlay?.querySelector('.rh-search__form');
    const input = form?.querySelector('input[type="search"][name="q"]');
    const results = overlay?.querySelector('[data-predictive-results]');
    if (!form || !input || !results) return;

    results.hidden = true;
    bindSearch({ form, input, results });
  };

  const addMobileSearchButton = () => {
    const header = document.querySelector('[data-rosemary-header]');
    const actions = header?.querySelector('.rh__side--end');
    if (!actions || actions.querySelector('.rh-primary-search-mobile')) return;

    const button = document.createElement('button');
    button.type = 'button';
    button.className = 'rh-icon rh-primary-search-mobile';
    button.setAttribute('data-search-open', '');
    button.setAttribute('aria-controls', 'RosemarySearchOverlay');
    button.setAttribute('aria-expanded', 'false');
    button.setAttribute('aria-label', getCopy().label);
    button.innerHTML = '<svg viewBox="0 0 24 24" aria-hidden="true"><circle cx="11" cy="11" r="7"></circle><path d="m16.5 16.5 4 4"></path></svg>';

    const cart = actions.querySelector('.rh-count');
    actions.insertBefore(button, cart || null);
  };

  const initPrimarySearch = () => {
    addStyles();
    enhanceDesktopSearch();
    enhanceOverlaySearch();
    addMobileSearchButton();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initPrimarySearch, { once: true });
  } else {
    initPrimarySearch();
  }

  document.addEventListener('shopify:section:load', initPrimarySearch);
  MOBILE_BREAKPOINT.addEventListener?.('change', addMobileSearchButton);
})();
